// extracted by mini-css-extract-plugin
export default {"container":"TruckBrandModule_container__rQXiV","vinEditMessage":"TruckBrandModule_vinEditMessage__HiiGo","row":"TruckBrandModule_row__7ES9z"};